import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'round-badge'
})
export default class RoundBadge extends Vue {
  
}
